import { post } from "@insite/client-framework/Services/ApiService";

export interface InquiryLineCardFormParamter {
   
    Name: string;
    CompanyName: string;
    Email: string;
    Website:string;
    PhoneNo:string;
    Address:string;
    City:string;
    State:string;
    ZipCode:string;
    RequestType:string;
    Message:string;
    onSuccess?: () => void;
}

export interface InquiryLineCardFormModel  {}

const createInquiryLineCardForm = "api/v2/email/generalinquiriesandlinecard";

export async function createInquiryLineCardFormService(parameter:InquiryLineCardFormParamter){
       const response = await post<InquiryLineCardFormModel>(createInquiryLineCardForm,parameter);
       return response;
}